var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"siteheader"},[_c('div',{staticClass:"siteheader__container"},[_c('LogoText'),_vm._v(" "),_c('a',{staticClass:"siteheader__help",on:{"click":function($event){$event.preventDefault();return _vm.openHeaderModal()}}},[_vm._v("\n            Hulp nodig?\n            ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }